<template>
  <div class="module-item">
    <div class="event-item-content">
      <div class="clearfix">
        <Date-picker
          class="date-box"
          :open="dateOpen"
          :value="dateValue"
          :options="datePickOptions"
          confirm
          type="daterange"
          @on-change="handleChange"
          @on-ok="handleOk"
          split-panels>
          <div class="ivu-date-picker-rel" @click="handleClick">
            <div class="ivu-input-wrapper ivu-input-type ivu-date-picker-editor">
              <i class="ivu-icon ivu-icon-ios-calendar-outline ivu-input-icon ivu-input-icon-normal"></i>
              <input type="text" :placeholder="$t('userGroupEvent.chooseDate')" class="ivu-input" v-model="showDate">
            </div>
          </div>
        </Date-picker>

        <span class="line-text">{{$t(`${typeName[callerType]}.userTrigger`)}}</span>
        <td-dropdown
          v-if="callerType !== 'launch_info'"
          class="select-box choose-box"
          :select-name="eventItem.id"
          :select-list="allDataList.loopData"
          :list-in-load="inLoad"
          :caller-type="callerType"
          :type-name="typeName"
          @select-id="chooseId"
        ></td-dropdown>
        <span v-if="showError" class="line-text error-repeat">
          <Icon color="#ed3f14" type="md-close-circle"></Icon>
          {{errorMsg}}
        </span>
      </div>
    </div>
    <!-- 项目操作按钮：删除Event按钮 -->
    <i
      v-if="itemLength>1"
      class="delete-item iconfont icon-removed"
      @click="deleteEvent"
    ></i>
  </div>
</template>
<script>
import tdDropdown from './td-dropdown';
import bus from '../../libs/bus';
import busModual from '../../libs/busModual';

export default {
  components: {
    tdDropdown,
  },
  props: {
    callerType: String,
    itemIndex: Number,
    itemLength: Number, // item个数
    typeName: {
      type: Object,
      default() {
        return {};
      },
    },
    eventItem: {
      type: Object,
      default() {
        return {};
      },
    },
    childInLoad: {
      type: Boolean,
      default() {
        return true;
      },
    },
    childSelectList: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      dateOpen: false,
      dateValue: this.eventItem.timeflag,
      dateRange: 0,
      isAllData: false, // 是否选择标准事件的标志
      errorMsg: '', // 错误提示内容
      showError: false, // 是否显示错误提示
      changeDate: false,
      msgKey: '',
      datePickOptions: {
        disabledDate(date) {
          const startTime = new Date(`${busModual.userRangeDate[0].replace(/-/g, '/')} 00:00:00`).getTime();
          return date && (date.valueOf() > Date.now() || date.valueOf() < startTime);
        },
      },
    };
  },
  computed: {
    // 事件列表
    allDataList() {
      return {
        loopData: this.childSelectList,
      };
    },
    inLoad() {
      return this.childInLoad;
    },
    showDate() {
      return this.dateValue.length ? this.dateValue.join(' - ') : '';
    },
  },
  mounted() {
    this.initData();

    bus.$on('on-usergroup-recover', () => {
      this.initData();
    });

    // 监听重复事件
    bus.$on('item-repeat', (callerType, errorIndex) => {
      // 要确定收到的是该事件组的重复判断
      if (callerType === this.callerType) {
        if (errorIndex === this.itemIndex) {
          this.errorMsg = this.$t('userGroupEvent.repeatBehavior');
          this.showError = true;
        } else {
          this.showError = false;
        }
      }
    });
    bus.$on('on-change-lang', this.changeLang);
  },
  beforeDestroy() {
    bus.$off('on-change-lang', this.changeLang);
  },
  methods: {
    changeLang() {
      this.errorMsg = this.$t(this.msgKey);
    },
    initData() {
      this.eventItem.hasError = false;
      this.showError = false;
    },
    // 选择事件id
    chooseId(id, name) {
      // 记录是否选择所有事件
      this.isAllEvents = id === 'allData';
      this.eventItem.allData = this.isAllData;
      this.eventItem.id = id;
      this.$set(this.eventItem, 'displayName', name);
      this.isAllInfo();
    },
    deleteEvent() {
      this.$emit('delete-event-item', this.itemIndex);
    },
    handleClick() {
      this.dateOpen = !this.dateOpen;
    },
    handleChange(date) {
      this.changeDate = true;
      this.dateValue = date;
    },
    isAllInfo() {
      let isAll = false;
      // 判断id是否选择
      if (((this.callerType === 'customevent' || this.callerType === 'page_view') &&
              !this.eventItem.id) || this.dateValue.length === 0) {
        isAll = false;
      } else {
        isAll = true;
      }

      // 数据不全时提示补充数据
      if (!isAll) {
        this.msgKey = 'userGroupEvent.choiceTip';
        this.setStatus(true, 'userGroupEvent.choiceTip');
        return;
      }
      // 时间跨度超过30天时提示
      if (this.dateRange <= 30) {
        this.setStatus(false);
      } else {
        this.setStatus(true);
      }
      // 派发编译表达式事件
      this.$emit('compile-expr');
    },
    // 确定选择日期
    handleOk() {
      // 取消提示
      this.showError = false;

      const start = new Date(this.dateValue[0]).getTime();
      const end = new Date(this.dateValue[1]).getTime();
      const diff = end - start;
      const days = diff / (24 * 60 * 60 * 1000);
      this.dateRange = days;

      // 开始时间应该晚于用户范围中选择的开始时间
      if (busModual.userRangeType === 'newuser' && !(busModual.userRangeDate[0] <= this.dateValue[0])) {
        // this.errorMsg = this.$t('userGroupEvent.tooEarly');
        this.msgKey = 'userGroupEvent.tooEarly';
        this.dateOpen = false;
        this.setStatus(true, 'userGroupEvent.tooEarly');
        return;
      }

      // 判断时间跨度是否超过30天
      if (days > 30) {
        this.dateOpen = false;
        this.msgKey = 'userGroupEvent.dateLt30';
        // this.errorMsg = this.$t('userGroupEvent.dateLt30');
        this.setStatus(true, 'userGroupEvent.dateLt30');
      } else {
        // 赋值，关闭日期选择框
        this.dateOpen = false;
        this.eventItem.timeflag = this.dateValue;
        this.isAllInfo();
      }
    },
    setStatus(status, msgKey) {
      // 设置错误信息
      if (msgKey) this.errorMsg = this.$t(msgKey);
      // 设置单个item是否显示提示，用来显示错误信息
      this.showError = status;
      // 错误信息传递，用于编译表达式时做判断
      this.eventItem.hasError = status;
      // 派发错误标志事件，处理选择时间后出错，不做其他处理直接保存的情况
      this.$emit('set-error-status', status);
    },
  },
};
</script>
